import React from 'react'
import { Button, Modal } from '@/components'
import type { useUserManagementViewModel } from '../useUserManagementViewModel'

type VM = ReturnType<typeof useUserManagementViewModel>

interface DeleteUserModalProps {
  showDeleteModal: VM['showDeleteModal']
  onClose: () => void
  deletingUser: VM['deletingUser']
  handleConfirmDelete: VM['handleConfirmDelete']
  /**
   * Modal ici hata slotu. Yikici islem hata verdiginde modal KAPANMAZ;
   * hata burada gorunur ve kullanici tekrar deneyebilir.
   */
  error: string | null
  onDismissError: () => void
  isSubmitting: boolean
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  showDeleteModal,
  onClose,
  deletingUser,
  handleConfirmDelete,
  error,
  onDismissError,
  isSubmitting,
}) => {
  return (
    <Modal
      isOpen={showDeleteModal && !!deletingUser}
      onClose={onClose}
      title="Kullanıcıyı Sil"
      error={error}
      onDismissError={onDismissError}
      isSubmitting={isSubmitting}
      size="sm"
      footer={
        <div className="flex justify-end space-x-3">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            İptal
          </Button>
          <Button
            onClick={handleConfirmDelete}
            loading={isSubmitting}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Sil
          </Button>
        </div>
      }
    >
      <div>
        <p className="text-gray-600">
          <strong>{deletingUser?.first_name} {deletingUser?.last_name}</strong> kullanıcısını silmek istediğinizden emin misiniz?
        </p>
        <p className="text-sm text-red-600 mt-2">
          Bu işlem geri alınamaz.
        </p>
      </div>
    </Modal>
  )
}

export default DeleteUserModal
